import React, { useCallback, useRef, useState } from 'react';
import { Form, Modal, ModalProps } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { LoadingButton } from './loading-button';

const AiTextInputModalStyles = createUseStyles({
	dialog: {
		width: '90%',
		height: '100%',
		maxWidth: 620,
		margin: '0 auto',
		'& .modal-content': {
			maxHeight: '90vh',
		},
		'& .hackett-modal__body': {
			overflowY: 'auto',
		},
	},
});

interface AiTextInputModalProps extends ModalProps {
	title: string;
	label: string;
	onSubmit(value: string): void;
	initialValue?: string;
	placeholder?: string;
	closeButtonTitle?: string;
	confirmButtonTitle?: string;
	isLoading?: boolean;
}

export const AiTextInputModal = ({
	title,
	label,
	onSubmit,
	initialValue = '',
	placeholder,
	cancelButtonTitle = 'Cancel',
	confirmButtonTitle = 'Confirm',
	isLoading = false,
	...props
}: AiTextInputModalProps) => {
	const classes = AiTextInputModalStyles();
	const [value, setValue] = useState('');
	const inputRef = useRef<HTMLInputElement>(null);

	const handleOnEntering = useCallback(() => {
		setValue(initialValue);
		inputRef.current?.focus();
	}, [initialValue]);

	const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		onSubmit(value);
	};

	return (
		<Modal dialogClassName={classes.dialog} centered onEntering={handleOnEntering} {...props}>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={handleFormSubmit}>
					<fieldset disabled={isLoading}>
						<Form.Label>{label}</Form.Label>
						<Form.Control
							ref={inputRef}
							className="mb-8"
							type="text"
							placeholder={placeholder}
							value={value}
							onChange={({ currentTarget }) => {
								setValue(currentTarget.value);
							}}
						/>
						<div className="d-flex align-items-center">
							<LoadingButton
								isLoading={isLoading}
								className="mr-3"
								variant="outline-primary"
								type="button"
								onClick={props.onHide}
							>
								{cancelButtonTitle}
							</LoadingButton>
							<LoadingButton isLoading={isLoading} variant="primary" type="submit">
								{confirmButtonTitle}
							</LoadingButton>
						</div>
					</fieldset>
				</Form>
			</Modal.Body>
		</Modal>
	);
};
